import { useContext } from "react";
import { Store } from "../Store";
import { Helmet } from "react-helmet-async";
import { Row, Col, ListGroup, Button, Card } from "react-bootstrap";
import MessageBox from "../Components/MessageBox";
import { Link, useNavigate } from "react-router-dom";
import { MdRemoveCircle, MdAddCircle, MdDelete } from "react-icons/md";
import axiosInstance from "../Util";

export default function CartScreen() {
  const navigate = useNavigate();
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    cart: { cartItems },
  } = state;

  const updateCartHandler = async (item, quantity, customization) => {
    const { data } = await axiosInstance.get(`/api/products/${item._id}`);
    if (data.countInStock < quantity) {
      window.alert("Sorry. Product is out of stock");
      return;
    }
    ctxDispatch({
      type: "CART_ADD_ITEM",
      payload: { ...item, quantity, ...customization },
    });
  };

  const removeItemHandler = (item) => {
    ctxDispatch({ type: "CART_REMOVE_ITEM", payload: item });
  };

  const checkoutHandler = () => {
    navigate("/signin?redirect=/shipping");
  };

  return (
    <div>
      <Helmet>
        <title>Shopping Cart</title>
      </Helmet>
      <h1 className='mb-3'>Shopping Cart</h1>
      <Row>
        <Col md={8}>
          {cartItems.length === 0 ? (
            <MessageBox>
              Cart is empty. <Link to='/'>Go Shopping</Link>
            </MessageBox>
          ) : (
            <ListGroup>
              {cartItems.map((item) => (
                <ListGroup.Item key={item._id}>
                  <Row className='align-items-center'>
                    <Col md={4}>
                      <img
                        src={item.image}
                        alt={item.name}
                        className='img-fluid rounded img-thumbnail'
                      ></img>{" "}
                      <Link to={`/product/${item.slug}`}>{item.name}</Link>
                    </Col>
                    <Col md={3}>
                      <div>
                        {item.category === "TVs" && (
                          <select
                            value={item.inches || ""}
                            onChange={(e) =>
                              updateCartHandler(item, item.quantity, {
                                inches: e.target.value,
                              })
                            }
                          >
                            <option value=''>Select Inches</option>
                            {(item.availableInches || []).map((inch) => (
                              <option key={inch} value={inch}>
                                {inch} inches
                              </option>
                            ))}
                          </select>
                        )}

                        {item.category === "Shoes" && (
                          <select
                            value={item.color || ""}
                            onChange={(e) =>
                              updateCartHandler(item, item.quantity, {
                                color: e.target.value,
                              })
                            }
                          >
                            <option value=''>Select Color</option>
                            {(item.availableColors || []).map((color) => (
                              <option key={color} value={color}>
                                {color}
                              </option>
                            ))}
                          </select>
                        )}

                        {item.category === "Pants" && (
                          <select
                            value={item.size || ""}
                            onChange={(e) =>
                              updateCartHandler(item, item.quantity, {
                                size: e.target.value,
                              })
                            }
                          >
                            <option value=''>Select Size</option>
                            {(item.availableSizes || []).map((size) => (
                              <option key={size} value={size}>
                                {size}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                      <Button
                        variant='dark'
                        onClick={() =>
                          updateCartHandler(item, item.quantity - 1)
                        }
                        disabled={item.quantity === 1}
                        className='icon-button cyan-background'
                      >
                        <MdRemoveCircle size={24} className='icon-cyan' />
                      </Button>{" "}
                      <span>{item.quantity}</span>{" "}
                      <Button
                        variant='dark'
                        onClick={() =>
                          updateCartHandler(item, item.quantity + 1)
                        }
                        disabled
                        className='icon-button cyan-background'
                      >
                        <MdAddCircle size={24} className='icon-cyan' />
                      </Button>
                    </Col>
                    <Col md={3}>${item.price}</Col>
                    <Col md={2}>
                      <Button
                        variant='dark'
                        onClick={() => removeItemHandler(item)}
                        className='icon-button red-background'
                      >
                        <MdDelete size={20} className='icon-red' />
                      </Button>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Col>
        <Col md={4}>
          <Card>
            <Card.Body>
              <ListGroup variant='flush'>
                <ListGroup.Item>
                  <h3>
                    Subtotal ({cartItems.reduce((a, c) => a + c.quantity, 0)}{" "}
                    items) : $
                    {cartItems.reduce((a, c) => a + c.price * c.quantity, 0)}
                  </h3>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className='d-grid'>
                    <Button
                      type='button'
                      variant='primary'
                      onClick={checkoutHandler}
                      disabled={cartItems.length === 0}
                    >
                      Purchase
                    </Button>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
